import cacheKeys from '../../interfaces/cacheKeyInterface';

export function getPageDataKey(route){
    if (!route.meta.backUrlTemplate){
        return null;
    }

    let key = `${cacheKeys.PAGE_DATA}_${route.meta.backUrlTemplate}`;

    Object.values(route.params).forEach(param => {
        if (param){
            key += `_${param}`;
        }
    })

    return key;
}

export function getLayoutPartsKey(data){
    return `${cacheKeys.LAYOUT_PARTS}_${data.locale}_${data.userId ? 'user' : 'guest'}`;
}

export function getBaseDataGamePlatformsKey(data){
    return `${cacheKeys.GAME_PLATFORM_DATA}_base_data_items_${data.locale}`;
}

export function getGamePlatformsKey(data){
    return `${cacheKeys.GAME_PLATFORM_DATA}_platforms_items_${data.locale}`;
}

export function getGamePlatformItemKey(data){
    return `${cacheKeys.GAME_PLATFORM_DATA}_game_platform_item_${data.slug}_${data.locale}`;
}

export function getGameCategoryItemBySlugKey(data){
    return `${cacheKeys.GAME_CATEGORY_DATA}_game_category_item_${data.slug}_${data.locale}`;
}

export function getGameVirtualCategoryItemByInterfaceCode(data){
    return `${cacheKeys.GAME_CATEGORY_DATA}_game_virtual_category_item_${data.apiId}_${data.locale}`;
}

export function getSliderSlidesKey(data){
    return `${cacheKeys.SLIDER_SLIDES}_${data.userId ? 'user' : 'guest'}_${data.locale}_${data.currency}_${data.sliderId}`;
}

export function getPromotionsDataKey(data){
    return `${cacheKeys.PROMOTION_DATA}_${data.userId ? 'user' : 'guest'}_all_${data.locale}_${data.currency}_${data.country}`;
}

export function getSliderPromotionsKey(data){
    return `${cacheKeys.PROMOTION_DATA}_${data.userId ? 'user' : 'guest'}_slider_${data.locale}_${data.currency}_${data.country}`;
}

export function getNewsKey(data){
    return `${cacheKeys.NEWS_DATA}_items_${data.category}_${data.tags.join('_')}_${data.page}_${data.locale}_${data.itemsLimit}`;
}

export function getNewsItemKey(data){
    return `${cacheKeys.NEWS_DATA}_news_item_${data.slug}_${data.locale}`;
}

export function getSliderNewsKey(data){
    return `${cacheKeys.NEWS_DATA}_news_slider_${data.slug}_${data.locale}`;
}

export function getNewsTagsKey(data){
    return `${cacheKeys.NEWS_DATA}_news_tags_${data.locale}`;
}

export function getNewsCategoriesKey(data){
    return `${cacheKeys.NEWS_DATA}_news_categories_${data.locale}`;
}

export function getHelpCategoriesKey(data){
    return `${cacheKeys.HELP_DATA}_help_categories_${data.locale}`;
}

export function getWinnerListKey(){
    return cacheKeys.WINNER_LIST;
}

export function getTranslationMessagesKey(data){
    return `${cacheKeys.TRANSLATION_MESSAGES}_locales_${data.locales.join('_')}_scopes_${data.scopes.join('_')}`;
}

export function getVipLevelsKey(){
    return cacheKeys.VIP_LEVELS;
}